import React, { useEffect, useState } from "react";
import '../invoice.css';
import moment from "moment";
const Details = ({data, onBack, type}:any) => {
    console.log(`../${data.slice(2)}`)
    return (
        <>
        {type!==2 ? (
            <div className="details-basic">
                {type===0 && (
                    <div className="details-section">
                    <h3 className="detail-title">Customer Invoice</h3>
                    <div className="subdetails">
                        <p className="subdetail-title">Invoice #</p>
                        <p  className="subdetail-value">{data?.invoiceNumber??"-"}</p>
                    </div>
                    <div className="subdetails">
                        <p className="subdetail-title">Invoice Date:</p>
                        <p  className="subdetail-value">{moment(data?.invoiceDate).format('MMM DD, YYYY')}</p>
                    </div>
                    <div className="subdetails">
                        <p className="subdetail-title">Prepared by:</p>
                        <p  className="subdetail-value">{data?.preparedBy??"-"}</p>
                    </div>
                    <div className="subdetails">
                        <p className="subdetail-title">Due Date:</p>
                        <p  className="subdetail-value">{moment(data?.dueDate).format('MMM DD, YYYY')}</p>
                    </div>
                </div>
                )}
                {type===1 && (
                    <div className="details-section">
                    <h3 className="detail-title">Billing Details</h3>
                    <div className="subdetails">
                        <p className="subdetail-title">Statement Date:</p>
                        <p  className="subdetail-value">-</p>
                    </div>
                    <div className="subdetails">
                        <p className="subdetail-title">Account Number:</p>
                        <p  className="subdetail-value">{data?.billAccount??"-"}</p>
                    </div>
                    <div className="subdetails">
                        <p className="subdetail-title">Billing Period:</p>
                        <p  className="subdetail-value">{data?.billPeriod??"-"}</p>
                    </div>
                </div>
                )}
                
                <div className="details-section">
                    <h3 className="detail-title">Payment Details</h3>
                    <div className="subdetails">
                        <p className="subdetail-title">Bank Name:</p>
                        <p  className="subdetail-value">{data?.paymentInformation?.bankName??"-"}</p>
                    </div>
                    <div className="subdetails">
                        <p className="subdetail-title">Account Number:</p>
                        <p  className="subdetail-value">{data?.paymentInformation?.accountNumber??"-"}</p>
                    </div>
                    <div className="subdetails">
                        <p className="subdetail-title">Swift Code:</p>
                        <p  className="subdetail-value">{data?.paymentInformation?.swiftCode??"-"}</p>
                    </div>
                    <div className="subdetails">
                        <p className="subdetail-title">Payment Terms:</p>
                        <p  className="subdetail-value">{data?.paymentInformation?.paymentTerms??"-"}</p>
                    </div>
                </div>
                
                {type===0 && data?.vesselInformation && (
                    <>
                        <div className="details-section">
                            <h3 className="detail-title">Vessel</h3>
                            <div className="subdetails">
                                <p className="subdetail-title">Vessel Name:</p>
                                <p  className="subdetail-value">{data?.vesselInformation?.vesselName??"-"}</p>
                            </div>
                            <div className="subdetails">
                                <p className="subdetail-title">IMO Number:</p>
                                <p  className="subdetail-value">{data?.vesselInformation?.imoNumber??"-"}</p>
                            </div>
                            <div className="subdetails">
                                <p className="subdetail-title">Port of Operation:</p>
                                <p  className="subdetail-value">{data?.vesselInformation?.portName??"-"}</p>
                            </div>
                            <div className="subdetails">
                                <p className="subdetail-title">Date of Operation:</p>
                                <p  className="subdetail-value">{moment(data?.vesselInformation?.operationDate).format('MMM DD, YYYY')}</p>
                            </div>
                        </div>
                        
                        <div className="details-section">
                            <h3 className="detail-title">Customer</h3>
                            <div className="subdetails">
                                <p className="subdetail-title">Company Name:</p>
                                <p  className="subdetail-value">{data?.customerInformation?.companyName??"-"}</p>
                            </div>
                            <div className="subdetails">
                                <p className="subdetail-title">Address:</p>
                                <p  className="subdetail-value">{data?.customerInformation?.address??"-"}</p>
                            </div>
                            <div className="subdetails">
                                <p className="subdetail-title">Contact Person:</p>
                                <p  className="subdetail-value">{data?.customerInformation?.contactPerson??"-"}</p>
                            </div>
                            <div className="subdetails">
                                <p className="subdetail-title">Email:</p>
                                <p  className="subdetail-value">{data?.customerInformation?.contactEmail??"-"}</p>
                            </div>
                            <div className="subdetails">
                                <p className="subdetail-title">Phone:</p>
                                <p  className="subdetail-value">{data?.customerInformation?.contactNumber??"-"}</p>
                            </div>
                        </div>
                    </>
                )}
                {type===1 && (
                    <>
                        <div className="details-section">
                            <h3 className="detail-title">Bill To</h3>
                            <div className="subdetails">
                                <p className="subdetail-title">Customer Name:</p>
                                <p  className="subdetail-value">{data?.customerInformation?.contactPerson??"-"}</p>
                            </div>
                            <div className="subdetails">
                                <p className="subdetail-title">Customer Address:</p>
                                <p  className="subdetail-value">{data?.customerInformation?.address??"-"}</p>
                            </div>
                            <div className="subdetails">
                                <p className="subdetail-title">Phone Number:</p>
                                <p  className="subdetail-value">{data?.customerInformation?.contactNumber??"-"}</p>
                            </div>
                            <div className="subdetails">
                                <p className="subdetail-title">Email:</p>
                                <p  className="subdetail-value">{data?.customerInformation?.contactEmail??"-"}</p>
                            </div>
                        </div>
                        
                        <div className="details-section">
                            <h3 className="detail-title">Terms & Conditions</h3>
                            <div className="subdetails">
                                <p className="subdetail-title">Payment Due Date:</p>
                                <p  className="subdetail-value">{moment(data?.termsAndConditions?.dueDate).format('MMM DD, YYYY')}</p>
                            </div>
                            <div className="subdetails">
                                <p className="subdetail-title">Late Payment Fee:</p>
                                <p  className="subdetail-value">{data?.termsAndConditions?.latePaymentFee??"-"}</p>
                            </div>
                            <div className="subdetails">
                                <p className="subdetail-title">Support:</p>
                                <p  className="subdetail-value">{data?.termsAndConditions?.supportContact??"-"}</p>
                            </div>
                            <div className="subdetails">
                                <p className="subdetail-title">Email Support:</p>
                                <p  className="subdetail-value">{data?.termsAndConditions?.supportEmail??"-"}</p>
                            </div>
                        </div>
                    </>
                )}
            </div>
        ):(
            <iframe
                src="https://qadworks.sharepoint.com/sites/QadWorks/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FQadWorks%2FShared%20Documents%2FStocExpo%2FDemo%20Files%2Fservice%20agreement%2Epdf&parent=%2Fsites%2FQadWorks%2FShared%20Documents%2FStocExpo%2FDemo%20Files&p=true&ga=1"
                frameBorder={0}
                style={{
                  position: "relative",
                  height: 1000,
                  width: "100%",
                  borderRadius: 4,
                }}
              ></iframe>
            // <iframe src={`file://service_agreement.pdf`} style={{width:'100%', minHeight:900, borderRadius:4, border:'none'}}></iframe>
            // <div className="details-long">
            //      <div className="details-section">
            //         <h3 className="detail-title">Scope of Work</h3>
            //         <p className="detail-description">[Party 1] agrees to provide the following services/products to [Party 2]:</p>
            //         <div className="subdetails">
            //             <p className="subdetail-title">Service/Product 1</p>
            //             <p  className="subdetail-value">[Brief Description]</p>
            //         </div>
            //         <div className="subdetails">
            //             <p className="subdetail-title">Service/Product 2</p>
            //             <p  className="subdetail-value">[Brief Description]</p>
            //         </div>
            //         <div className="subdetails">
            //             <p className="subdetail-title">Additional Deliverables</p>
            //             <p  className="subdetail-value">[Brief Description]</p>
            //         </div>
            //     </div>
              
            //     <div className="details-section">
            //         <h3 className="detail-title">Payment Terms</h3>
            //         <div className="subdetails">
            //             <p className="subdetail-title">Total Payment Amount:</p>
            //             <p  className="subdetail-value">[Amount in Currency]</p>
            //         </div>
            //         <div className="subdetails">
            //             <p className="subdetail-title">Payment Schedule:</p>
            //             <p  className="subdetail-value">[Payment breakdown, e.g., 50% upfront, 50% upon completion]</p>
            //         </div>
            //         <div className="subdetails">
            //             <p className="subdetail-title">Late Payment Penalties:</p>
            //             <p  className="subdetail-value">[Specify penalty if applicable]</p>
            //         </div>
            //         <p className="detail-description">Payments shall be made via [Payment Method, e.g., bank transfer, PayPal] to the following account:</p>
            //         <div className="subdetails">
            //             <p className="subdetail-title">Bank Name:</p>
            //             <p  className="subdetail-value">[Bank Name]</p>
            //         </div>
            //         <div className="subdetails">
            //             <p className="subdetail-title">Account Name:</p>
            //             <p  className="subdetail-value">[Account Name]</p>
            //         </div>
            //         <div className="subdetails">
            //             <p className="subdetail-title">Account Number:</p>
            //             <p  className="subdetail-value">[Account Number]</p>
            //         </div>
            //     </div>
             
            //     <div className="details-section">
            //         <h3 className="detail-title">Duration and Termination</h3>
            //         <ul>
            //             <li className="detail-bullet">This Agreement shall be effective from [Start Date] and will continue until [End Date] unless terminated earlier by either Party.</li>
            //             <li className="detail-bullet">Either Party may terminate this Agreement by providing [Number] days' written notice.</li>
            //             <li className="detail-bullet">Termination shall not affect any rights or obligations accrued prior to termination.</li>
            //         </ul>
            //     </div>
                
            //     <div className="details-section">
            //         <h3 className="detail-title">Confidentiality</h3>
            //         <p className="detail-description">Both Parties agree not to disclose confidential information obtained during the term of this Agreement to any third party without prior written consent.</p>
            //     </div>
                
            //     <div className="details-section">
            //         <h3 className="detail-title">Intelectual Property Rights</h3>
            //         <ul>
            //             <li className="detail-bullet">Any intellectual property created during this engagement shall be owned by [Party 1 / Party 2], unless otherwise agreed in writing.</li>
            //             <li className="detail-bullet">Any use of trademarks, copyrights, or proprietary materials shall require written approval.</li>
            //         </ul>
            //     </div>
                
            //     <div className="details-section">
            //         <h3 className="detail-title">Liability & Idemnification</h3>
            //         <ul>
            //             <li className="detail-bullet">[Party 1] shall not be liable for any indirect, incidental, or consequential damages arising from this Agreement.</li>
            //             <li className="detail-bullet">Each Party agrees to indemnify and hold harmless the other from any legal claims or disputes arising from breaches of this Agreement.</li>
            //         </ul>
            //     </div>
                 
            //     <div className="details-section">
            //         <h3 className="detail-title">Force Majeure</h3>
            //         <p className="detail-description">Neither Party shall be liable for failure to perform obligations under this Agreement due to unforeseen events beyond their control, such as natural disasters, government actions, or emergencies.</p>
            //     </div>
              
            //     <div className="details-section">
            //         <h3 className="detail-title">Amendments</h3>
            //         <p className="detail-description">Any modifications or amendments to this Agreement must be in writing and signed by both Parties.</p>
            //     </div>
              
            //     <div className="details-section">
            //         <h3 className="detail-title">Entire Agreement</h3>
            //         <p className="detail-description">This Agreement represents the entire understanding between the Parties and supersedes any prior agreements, whether written or oral.</p>
            //     </div>
            // </div>
        )
        }
        </>
    )
}

export default Details;